module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content",
    on: {
      "scroll": _vm.onScroll
    }
  }, [_c('div', {
    staticClass: "wallpaper"
  }, [_c('div', {
    staticClass: "backpaper",
    style: (_vm.styleObj)
  }), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._t("title"), _vm._v(" "), _c('p', {
    staticClass: "title-line"
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "map-box"
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01ba6c1f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/wall.vue
// module id = 194
// module chunks = 1